import { useRef } from 'react';

import UserService from '@src/services/UserService';

import useDebouncedRemoteSearch from './useDebouncedRemoteSearch';

const SEARCH_PAGE_SIZE = 8;
const USER_SEARCH_FIELDS = ['firstName', 'lastName', 'idCard'];

const useSidebarUserSearch = ({ enabled, orgId, searchTerm }) => {
  const userServiceRef = useRef(null);

  if (userServiceRef.current === null) {
    userServiceRef.current = new UserService();
  }

  const { results, loading, error } = useDebouncedRemoteSearch({
    enabled: enabled && Boolean(orgId),
    searchTerm,
    scopeKey: orgId || '',
    search: async normalizedTerm => {
      const result = await userServiceRef.current.listElastic(
        {
          orgId,
          from: 0,
          pageSize: SEARCH_PAGE_SIZE,
          searchTerm: normalizedTerm,
          searchFields: USER_SEARCH_FIELDS,
          state: 'all',
        },
        true,
      );
      return result?.users || [];
    },
  });

  return { users: results, loading, error };
};

export default useSidebarUserSearch;
